import React from 'react'
import { getIconClass } from '../../../helpers'
import 'react-phone-number-input/style.css' // Don't forget to import the styles
import { useFormContext } from '../../../providers'
import PhoneNumberInput from './PhoneNumberInput';


export const EmergencyContact = () => {
    // Set up the form with react-hook-form and validation
    const { register, errors, setValue, fieldRefs } = useFormContext();

    return (
        <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-md">

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
                className="dashboard-title"
            >
                <h3>Emergency Contact</h3>
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div ref={(el) => (fieldRefs.current["contact_name"] = el)}>
                    <label className="block text-sm font-medium">
                        Contact Name{" "}
                        <i className={getIconClass("Contact Name")} />
                    </label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded-md"
                        {...register('contact_name', { onChange: (e) => setValue('contact_name', e.target.value, { shouldValidate: true }) })}
                        placeholder="Contact Name"
                    />
                    {errors.contact_name && (
                        <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.contact_name.message}</span>
                    )}
                </div>

                <div ref={(el) => (fieldRefs.current["contact_relationship"] = el)}>
                    <label className="block text-sm font-medium">
                        Relationship{" "}
                        <i className={getIconClass("Relationship")} />
                    </label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded-md"
                        {...register('contact_relationship', { onChange: (e) => setValue('contact_relationship', e.target.value, { shouldValidate: true }) })}
                        placeholder="(Cannot be Yourself)"
                    />
                    {errors.contact_relationship && (
                        <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.contact_relationship.message}</span>
                    )}
                </div>

                <div style={{ marginTop: "12px" }} ref={(el) => (fieldRefs.current["contact_email"] = el)}>
                    <label className="block text-sm font-medium">
                        Email <i className={getIconClass("Email")} />
                    </label>
                    <input
                        type="email"
                        className="w-full p-2 border rounded-md"
                        {...register('contact_email', { onChange: (e) => setValue('contact_email', e.target.value, { shouldValidate: true }) })}
                        placeholder="Email"
                    />
                    {errors.contact_email && (
                        <span className="inline-block w-full overflow-hidden text-xs text-red-500 truncate whitespace-nowrap">{errors.contact_email.message}</span>
                    )}
                </div>

                <div style={{ marginTop: "12px" }} ref={(el) => (fieldRefs.current["contact_phone"] = el)}>
                    <PhoneNumberInput name="contact_phone" label="Phone Number" defaultCountry="US" />
                </div>
            </div>
        </div>
    )
}
